// import { gsap } from "gsap";
    
// import { ScrollTrigger } from "gsap/ScrollTrigger";


// // Make sure to register the ScrollTrigger plugin
// gsap.registerPlugin(ScrollTrigger);

// gsap.utils.toArray(".color-section").forEach(section => {
//   gsap.from(section, {
//     opacity: 0,
//     y: 50,
//     duration: 0.5,
//     ease: "power1.out",
//     scrollTrigger: {
//       trigger: section,
//       start: "top 80%", // When the top of the section hits 80% of the viewport
//       end: "bottom 20%", // When the bottom of the section hits 20% of the viewport
//       toggleActions: "play reverse play reverse", 
//       // This means:
//       // onEnter: play the animation (animate in)
//       // onLeave: reverse the animation (animate out)
//       // onEnterBack: play the animation (animate in when scrolling up)
//       // onLeaveBack: reverse (animate out when scrolling up)
//       // markers: true // uncomment to see the trigger markers during development
//     }
//   });
// });

